import React, { useState, useEffect } from "react";
import OwnAgentName from "../OwnAgents/ownAgentComp/ownAgentName";
import NumberToCall from "./numberToCall/NumberToCall";
import axios from "axios";
// import axios from "axios";
import {
  concrete_restoration,
  dock_and_deck,
  painting,
  pavers_landscaping,
  pool_renovation,
  roofing,
  seawalls,
  stucco_repair,
  waterproofing,
} from "../../../constants";

const BuildNewScript = () => {
  const [promptType, setPromptType] = useState("");
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const [user, setUser] = useState("");
  const [scriptData, setScriptData] = useState(null);
  var authToken = JSON.parse(localStorage.getItem("bearerToken"));
  const [ValueType, setValueType] = useState(false);

  const HandleCreateAgent = (promptTypeName, name, scriptTest) => {
    try {
      console.log("scriptTest:", scriptTest);
      axios
        .post(
          `${process.env.REACT_APP_API_URL}/customer/agent`,
          {
            promptType: promptTypeName,
            agentName: name +"("+ promptTypeName+")",
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        )
        .then((response) => {
          console.log(response.data, "data======");

          axios
            .post(
              `${process.env.REACT_APP_API_URL}/customer//update-script/${response.data._id}`,
              {
                script: scriptTest,
              },
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${authToken}`,
                },
              }
            )
            .then((response) => {
              console.log(response.data);
              setUser(response.data);
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.error("Error:", error.message);
    }
  };

  const handleButtonClick = (value, promptype) => {
    // setIsButtonClicked(value);
    console.log(value, "clc````  clc****************", promptype);
    // setValueType(value)
    const name = "Alexander";

    if (promptype === "Stucco Repair") {
      // setScriptData(stucco_repair);
      HandleCreateAgent(promptype, name, stucco_repair(name));
    } else if (promptype === "Concrete Restoration") {
      HandleCreateAgent(promptype, name, concrete_restoration(name));
      // setScriptData(  concrete_restoration(name));
    } else if (promptype === "Painting") {
      // setScriptData(painting(name));
      HandleCreateAgent(promptype, name, painting(name));
    } else if (promptype === "Roofing") {
      // setScriptData(roofing(name));
      HandleCreateAgent(promptype, name, roofing(name));
    } else if (promptype === "Waterproofing") {
      setScriptData(waterproofing(name));
    } else if (promptype === "Pool Renovation & Restoration") {
      // setScriptData(pool_renovation(name));
      HandleCreateAgent(promptype, name, pool_renovation(name));
    } else if (promptype === "Pavers and Landscaping") {
      // setScriptData(pavers_landscaping(name));
      HandleCreateAgent(promptype, name, pavers_landscaping(name));
    } else if (promptype === "Dock & Deck") {
      // setScriptData(dock_and_deck(name));
      HandleCreateAgent(promptype, name, dock_and_deck(name));
    } else if (promptype === "Seawalls") {
      // setScriptData(seawalls(name));
      HandleCreateAgent(promptype, name, seawalls(name));
    }
    console.log("I AM HERE : " + name);
    setIsButtonClicked(value);
  };

  useEffect(() => {
    console.log("ValueType: ", user);
  }, [user]);

  return (
    <>
      {!isButtonClicked ? (
        <div className="renovateWrapper">
          <h4>Renovate your Construction</h4>
          <div className="renovateNameWrapper">
            {/* <p>Button clicked: {isButtonClicked.toString()}</p> */}
            <OwnAgentName
              title="Pool Renovation & Restoration"
              btnShow={false}
              onButtonClick={handleButtonClick}
              showUpdate={false}
              />
            <OwnAgentName
              title="Pavers and Landscaping"
              btnShow={false}
              onButtonClick={handleButtonClick}
              showUpdate={false}
            />
            <OwnAgentName
              title="Dock & Deck"
              btnShow={false}
              onButtonClick={handleButtonClick}
              showUpdate={false}
            />
            <OwnAgentName
              title="Seawalls"
              btnShow={false}
              onButtonClick={handleButtonClick}
              showUpdate={false}
            />
          </div>
        </div>
      ) : (
        <>
          {user ? (
            <NumberToCall promptType={promptType} agentData={user} />
          ) : (
            <></>
          )}
        </>
      )}
    </>
  );
};

export default BuildNewScript;
